import { Component, OnInit } from '@angular/core';


@Component({
    selector: 'loadingAnimation',
    template: require('./loading.component.html'),
    styles: [require('./loading.component.css')]
})

export class LoadingAnimationComponent {
    constructor(){}       


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/loading/loading.components.ts